/* BANBROKEN · fecha estimada de entrega (península por defecto).
   Rellena cualquier elemento con data-bb-entrega="frase" | "dia" | "cuenta".
   Corte 14:00 hora de Madrid, lun–vie, sin festivos nacionales. Península 1–2 días laborables (se muestra el primero). */
(function () {
  var FEST = ['2026-10-12','2026-11-01','2026-12-08','2026-12-25','2027-01-01','2027-01-06','2027-04-02','2027-05-01','2027-08-15','2027-10-12','2027-11-01','2027-12-06','2027-12-08','2027-12-25'];
  var DIAS = ['dom','lun','mar','mié','jue','vie','sáb'];
  var MES = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
  function calc() {
    var parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
    var g = function (t) { for (var i = 0; i < parts.length; i++) if (parts[i].type === t) return Number(parts[i].value); return 0; };
    var h = g('hour') % 24, m = g('minute');
    var d = new Date(Date.UTC(g('year'), g('month') - 1, g('day')));
    var cerrado = function (x) { var w = x.getUTCDay(); return w === 0 || w === 6 || FEST.indexOf(x.toISOString().slice(0, 10)) >= 0; };
    var sig = function (x) { var y = new Date(x.getTime()); do { y.setUTCDate(y.getUTCDate() + 1); } while (cerrado(y)); return y; };
    var hoy = !cerrado(d) && h < 14;
    var sale = hoy ? d : sig(d);
    var llega = sig(sale);
    var resta = 14 * 60 - (h * 60 + m);
    var dia = DIAS[llega.getUTCDay()] + ' ' + llega.getUTCDate() + ' ' + MES[llega.getUTCMonth()];
    var cuenta = hoy ? Math.floor(resta / 60) + ' h ' + (resta % 60) + ' min' : '';
    return { hoy: hoy, dia: dia, cuenta: cuenta };
  }
  function paint() {
    var e = calc();
    document.querySelectorAll('[data-bb-entrega]').forEach(function (el) {
      var k = el.getAttribute('data-bb-entrega');
      if (k === 'dia') el.textContent = e.dia;
      else if (k === 'cuenta') el.textContent = e.cuenta;
      else if (k === 'frase' || k === 'pedido') {
        var w = k === 'pedido' ? 'recíbelo' : 'recíbelas';
        el.innerHTML = e.hoy
          ? 'Pide en las próximas <b class="bbv4-mark">' + e.cuenta + '</b> y ' + w + ' el <b>' + e.dia + '</b>.'
          : 'Pide hoy y ' + w + ' el <b>' + e.dia + '</b>.';
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint); else paint();
  setInterval(paint, 30000);
  document.addEventListener('shopify:section:load', paint);
  document.addEventListener('cart:updated', function () { setTimeout(paint, 50); });
  /* la cesta lateral se vuelve a pintar al cambiar: rellenar las fechas nuevas */
  var pend = false;
  if ('MutationObserver' in window) new MutationObserver(function () {
    if (pend) return; pend = true;
    setTimeout(function () { pend = false; var n = document.querySelector('[data-bb-entrega]:empty'); if (n) paint(); }, 30);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
